export default "__VITE_ASSET__XIgYF2pb__"